import React from 'react';
import {
	Dropdown,
	MenuItem
} from 'react-bootstrap';
import {
	array,
} from 'prop-types';
import IconButton from '../../atoms/IconButton';
import { OptionVerticalIcon } from '../../atoms/Icons';

class CustomToggle extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(e) {
		e.preventDefault();
		this.props.onClick(e);
	}

	render() {
		return (
			<span onClick={this.handleClick}>
				{this.props.children}
			</span>
		);
	}
}

const DropDown = ({ options, ...props }) => {
	if (!options) return null;
	const items = options.map(data => (
		<MenuItem key={data.name} onClick={data.callback}> {data.name} </MenuItem>
	));
	return (
		<Dropdown id="dropdown-custom-menu"  {...props}>
			<CustomToggle bsRole="toggle">
				<IconButton >
					<OptionVerticalIcon />
				</IconButton>
			</CustomToggle>

			<Dropdown.Menu >
				{items}
			</Dropdown.Menu>
		</Dropdown>
	);
};

DropDown.propTypes = {
	options: array,
};

export default DropDown;